import { AxiosError } from 'axios';
import { ResponseInterceptor } from '@/Http';

export enum RequestFail {
    需要授权 = '需要授权',
    非法访问 = '非法访问',
    其他错误 = '其他错误',
    没有响应 = '没有响应',
}

export const HttpStateCodeHandler: ResponseInterceptor = {
    onRejected: (error: AxiosError): AxiosError | Promise<AxiosError> => {
        const response = error.response;
        if (response !== undefined) {
            if (response.status === 401) throw RequestFail.需要授权;
            if (response.status === 403) throw RequestFail.非法访问;
            throw RequestFail.其他错误;
        }
        throw RequestFail.没有响应;
    },
};
